<template>
    <el-container class="mainBody">
        <el-main class="gcfhDiv">
            <el-row>
                <el-col class="leftTable">
                    <div >
                        <el-row class="bgxzlieTitle" >{{zcfgList.BT}}</el-row>
                        <el-row  class="biaotouWZ">
                            <el-col :span="4"  class="date">
                                <span class="biaotouImg"><img :src="require('../img2/bgxz/date.png')"/></span>
                                <span>{{zcfgList.CJSJ}}</span>
                            </el-col>
                            <el-col :span="7"  class="name">
                                <span class="biaotouImg"><img :src="require('../img2/bgxz/name.png')"/></span>
                                <span>{{zcfgList.CZZ}}</span>
                            </el-col>
                            <el-col :span="7" class="liulan">
                                <span class="biaotouImg"><img :src="require('../img2/bgxz/liulan.png')"/></span>
                                <span>{{zcfgList.BFL}}</span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <div v-html="zcfgList.NR" CLASS="divcss5"></div>
                        </el-row>
                        <el-row class="LinkToOther">
                            <el-col :span="2">上一篇</el-col>
                            <el-col :span="1" class="dianCss"><div class="tableTabs"></div></el-col>
                            <el-col :span="14"><a @click="OpenXx(LastList.ID,LastList.XSSX)">{{LastList.BT}}</a></el-col>
                        </el-row>
                        <el-row class="LinkToOther">
                            <el-col :span="2" >下一篇</el-col>
                            <el-col :span="1" class="dianCss"><div class="tableTabs"></div></el-col>
                            <el-col :span="14"><a @click="OpenXx(NestList.ID,NestList.XSSX)">{{NestList.BT}}</a></el-col>
                        </el-row>
                    </div>
                </el-col>
                <el-col class="rightTable">
                    <el-tabs v-model="activeName">
                        <el-tab-pane  label="热门资讯" name="first" >
                            <el-table
                                    class="tablermzx"
                                    :data="tableData1"
                                    :show-header="false" >
                                <el-table-column
                                        label=""
                                        width="30"
                                        align="center" class-name="phbNum">
                                    <div class="tableTabs">

                                    </div>
                                </el-table-column>
                                <el-table-column
                                        prop="name"
                                        width="380"
                                        label=""
                                >
                                    <template slot-scope="scope">
                                        <span @click="OpenXw(scope.row.id,scope.row.xssx,scope.row.wldz)">
                                            {{scope.row.name}}
                                        </span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                        <el-tab-pane label="最新资讯" name="second">
                            <el-table
                                    :data="tableData2"
                                    :show-header="false">
                                <el-table-column
                                        label=""
                                        width="30"
                                         align="center" class-name="phbNum">
                                    <div class="tableTabs">
                                    </div>
                                </el-table-column>
                                <el-table-column
                                        prop="name"
                                        width="380"
                                        label=""
                                >
                                    <template slot-scope="scope">
                                        <span @click="OpenXw(scope.row.id,scope.row.xssx,scope.row.wldz)">
                                            {{scope.row.name}}
                                        </span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                    </el-tabs>
                </el-col>
            </el-row>
        </el-main>
    </el-container>
</template>

<script>
    import {mapActions} from "vuex";

    export default {
        name: "zcfg",
        data() {
            return {
                activeName: 'first',
                tableData4:[],
                zcfgList:[],
                NestList: {
                    BT:'',
                    XSSX:'',
                },
                LastList:{
                    BT:'',
                    XSSX:'',
                },
                currentPage:1, //初始页
                pagesize:5,    //    每页的数据
                totalCount:50,
                papercount:5,
                tableData1: [],
                tableData2: [],
                idVal:this.$route.query.id==null?1:this.$route.query.id,
            }
        },
        methods: {
            ...mapActions([
                'Ymxxinit','getZcxwxxByid'
            ]),
            OpenXx(idVal,XSSX){
                this.$route.query.id=idVal;
                this.$route.query.xssx=XSSX;
                this.YmxxInitZcxw();
            },
            warnMessage(obj) {
                this.$alert(obj, '温馨提示', {
                    confirmButtonText: '确定',
                });
            },
            tableRowClassName({row, rowIndex}) {
                /*if ( rowIndex%2 ==0) {
                    return '';
                } else if (rowIndex%2 !=0) {
                    return 'css-row';
                }*/
                return 'css-row';
            },
            YmxxInitZcxw(){
                this.getZcxwxxByid({_module:'TT',_method:'getZcxwxxByid',cxlx:"1",id:this.$route.query.id,xssx:this.$route.query.xssx}).then((res) => {
                    if (res._result.zcxwList !=null ) {
                        this.zcfgList=res._result.zcxwList;
                        if (res._result.LastMap !=null ) {
                            this.LastList=res._result.LastMap;
                        }
                        if (res._result.NestMap !=null ) {
                            this.NestList=res._result.NestMap;
                        }
                    }else{
                        this.warnMessage("没有查到信息")
                    }
                })
            },
            OpenXw(idVal,XSSX,WLDZ){
                if(WLDZ!=null&&WLDZ!="null"){
                    window.open(WLDZ);
                }else{
                    this.$router.push({path:'/ywhome/xwXxjm',query:{id:idVal,xssx:XSSX}})
                }

            },
        },
        created() {
            /*查询类型 cxlx 1政策法规 2热门资讯 3 最新资讯*/
            this.YmxxInitZcxw();
            this.Ymxxinit({_module:'TT',_method:'getZcfgxxInit',"numPerPage": "10","pageNum": 1,cxlx:"2"}).then((res) => {
                if (res._page.results !=null ) {
                    var arrayObj = new Array(11);
                    for(let i=0;i<res._page.results.length;i++){
                        const item1 = {
                            name: res._page.results[i].BT,
                            id:res._page.results[i].ID,
                            xssx:res._page.results[i].XSSX,
                            wldz:res._page.results[i].WLDZ,
                        };
                        arrayObj.push(item1)
                    }
                    this.tableData1=arrayObj;
                }
            })

            this.Ymxxinit({_module:'TT',_method:'getZcfgxxInit',"numPerPage": "10","pageNum": 1,cxlx:"3"}).then((res) => {
                if (res._page.results !=null ) {
                    var arrayObj = new Array(11);
                    for(let i=0;i<res._page.results.length;i++){
                        const item1 = {
                            name: res._page.results[i].BT,
                            id:res._page.results[i].ID,
                            xssx:res._page.results[i].XSSX,
                            wldz:res._page.results[i].WLDZ,
                        };
                        arrayObj.push(item1)
                    }
                    this.tableData2=arrayObj;
                }
            })
        }
    }
</script>



<style>
    .mainBody .gcfhDiv .el-table__body{
        width: 94% !important;
    }
    .mainBody .gcfhDiv  .el-table__body{
        display: flex;
    }
    .gcfhDiv .el-button--primary{
        background-color: #00448C;
    }
    .gcfhDiv .el-tabs__nav-wrap::after {
        position: static !important;
    }
    .gcfhDiv .el-image__inner--center{
        transform:none;
        top: 0;
        left: 0;
    }
    .gcfhDiv .el-tabs__item{
        color: #666666;
        font-weight: bold;
    }
    .gcfhDiv .el-tabs__item.is-active {
        color: #00448C;
    }
    .gcfhDiv .el-tabs__item:hover {
        color: #00448C;
        cursor: pointer;
    }
    .gcfhDiv .el-tabs__active-bar{
        background-color: #00448C;
    }
    .gcfhDiv .el-table__header{
        background-color: #F8F8F8;
    }
    .biaotouWZ{
        margin-top: 10px;
        font-size: 12px !important;
        line-height: 20px;
    }
    .divcss5{
        word-wrap: break-word;
        word-break: break-all;
        overflow: hidden;
    }
    /*移动端样式*/
    @media screen and (max-width: 414px) {
        .el-tabs__item{
            font-size: 13px;
        }
        .el-main {
            font-size: 13px !important;
        }
        .el-table .cell{
            font-size: 13px !important;
        }
        .el-table td, .el-table th{
            padding: 9px 0;
        }
        .date{
            width: 30%;
        }
        .name{
            width: 58%;
        }
        .lilan{
            width: auto;
        }
        .bgxzlieTitle{
            font-size: 18px;
            font-weight: 600;
        }
        .rightTable .el-tabs__item{
            font-size: 18px !important;
            font-weight: 600;
        }
        .rightTable{
            margin-top: 20px;
        }
        .bgxzGeliImg img{
            width: 18%;
        }
        .bgxzHengImg{
            margin-top: 10px;
        }
        .divcss5{
            margin-top: 20px;
        }
    }
    /*PC端样式*/
    @media screen and (min-width: 414px) {
        .gcfhDiv .bgxzHengImg{
            margin-top: 20px;
            width: 100%;
        }
        .mainBody{
            width: 80%;
            margin: 10px auto;
            overflow-x: hidden;
        }
        .leftTable{
            width: 68%;
        }
        .rightTable{
            width: 32%;
        }
        .biaotouImg{
            margin-right: 5px;
        }
        .bgxzlieTitle{
            font-size: 22px;
            font-weight: 600;
        }
        .rightTable .el-tabs__item{
            font-size: 22px !important;
            font-weight: 600;
        }
        .divcss5{
            margin-top: 40px;
        }
    }
    .gcfhDiv .el-table td, .el-table th.is-leaf{
        border: none !important;
    }
    .css-row{
        height: 135px;
    }
    .el-pagination{
        margin-top: 30px;
        display: flex;
        justify-content: center;
    }
    .gcfhDiv .bgxzlie{
        line-height: 30px !important;
        max-width: 900px;
    }
    .bgxzGeliImg{
        margin-top: 10px;
    }
    .LinkToOther{
        margin-top: 20px;
        font-weight: 600;
        display: flex;
    }
    .dianCss{
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
<style scoped>
    .tableTabs{
        width: 8px;
        height: 8px;
        background: #00448c;
        border-radius: 50%;
    }

</style>